<template>
  <v-dialog persistent width="450" v-model="dialogOpen">
    <v-card>
      <v-card-title>Pain Points</v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-autocomplete multiple v-model="pain_points" label="Pain Points" :items="getPainPoints" :error-messages="painPointsErrors" :hide-details="painPointsErrors.length===0" @change="$v.pain_points.$touch()" @blur="$v.pain_points.$touch()" :disabled="formLoading" outlined dense required></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea v-model="pain_points_notes" label="Pain point notes" :error-messages="painPointsNotesErrors" @change="$v.pain_points.$touch()" @blur="$v.pain_points_notes.$touch()" :disabled="formLoading" outlined dense :counter="1024" ></v-textarea>
          </v-col>
        </v-row>

        <v-row class="mt-n3">
          <v-col>
            <v-textarea v-model="current_setup" label="Current Setup" :error-messages="currentSetupErrors" @change="$v.current_setup.$touch()" @blur="$v.current_setup.$touch()" :disabled="formLoading" outlined dense :counter="200" ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="save" :disabled="formLoading" :loading="formLoading">Save</v-btn>
        <v-btn color="primary" outlined small @click="close">cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { validationMixin } from "vuelidate";
  import { required,maxLength } from "vuelidate/lib/validators";
  import { mapGetters,mapActions,mapState } from "vuex";

  export default {
    props: {
      dialogOpen:{
        type: Boolean,
        default: false
      }
    },

    mixins: [ validationMixin ],

    validations: {
      pain_points: { required },
      pain_points_notes: { maxLength: maxLength(1024) },
      current_setup: { maxLength: maxLength(200) }
    },

    data() {
      return {
        pain_points: [],
        pain_points_notes : '',
        current_setup: '',
        formLoading: false,
      }
    },

    computed: {
      ...mapState('leads',['currentLead']),
      ...mapGetters('leads',['getPainPoints']),

      painPointsErrors() {
        const errors = [];
        if (!this.$v.pain_points.$dirty) return errors;
        !this.$v.pain_points.required && errors.push("Pain Points is required");
        return errors;
      },

      painPointsNotesErrors() {
        const errors = [];
        if (!this.$v.pain_points_notes.$dirty) return errors;
        !this.$v.pain_points_notes.maxLength && errors.push("Pain points notes has too many characters");
        return errors;
      },

      currentSetupErrors() {
        const errors = [];
        if (!this.$v.current_setup.$dirty) return errors;
        !this.$v.current_setup.maxLength && errors.push("Current Setup has too many characters");
        return errors;
      }
    },

    watch: {
      dialogOpen(val) {
        if(val){
          this.pain_points = this.currentLead.pain_points;
          this.pain_points_notes = this.currentLead.pain_points_notes;
          this.current_setup = this.currentLead.current_setup;
        }
      }
    },

    methods: {
      ...mapActions('leads',['updatePainPoints']),

      reset() {
        this.$v.$reset();
        this.pain_points = [];
        this.pain_points_notes = '';
        this.current_setup = '';
      },

      close() {
        this.reset();
        this.$emit('close-dialog');
      },

      async save() {
        this.$v.$touch();
        if(!this.$v.$error){
          this.formLoading = true;
          let data = {
            id: this.currentLead.id,
            data: { pain_points: this.pain_points, pain_points_notes: this.pain_points_notes, current_setup: this.current_setup }
          };
          try{
            await this.updatePainPoints({sentData: data});
            this.formLoading = false;
            this.close();
          }catch(error){
            this.formLoading = false;
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped></style>
